import { render, staticRenderFns } from "./LoginJump.vue?vue&type=template&id=24496003&"
import script from "./LoginJump.vue?vue&type=script&lang=js&"
export * from "./LoginJump.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports